module.exports = __webpack_public_path__ + "img/latLogo.67b67420.png";